import {
  Box,
  Button,
  HStack,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import DashboardImage from '../../../assets/images/dashboard_referidos.png'
import UserIcon from '../../../components/SvgIcon/icons/UserIcon'
import { useRequestStatusContext } from '../../../utils/hooks/Context/RequestStatusContext'
import { colors } from '../../../utils/theme/styles'
import { useLoadingContext } from '../../../utils/hooks/Context/LoadingContext'
import { REPOSITORY } from '../../../api/repository/Repository'

const initialValue = {
  nombreEmpresa: '',
  nombreContactoEmpresa: '',
  telefonoContactoEmpresa: '',
  mailContactoEmpresa: '',
  tuNombre: '',
  tuCorreo: '',
}

const validateSchema = Yup.object().shape({
  nombreEmpresa: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  nombreContactoEmpresa: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  telefonoContactoEmpresa: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  mailContactoEmpresa: Yup.string().email('Invalid email').required('Required'),
  tuNombre: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
  tuCorreo: Yup.string().email('Invalid email').required('Required'),
})

export function ReferidoAction() {
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const [open, setOpen] = useState(false)

  const handleToggleModal = () => {
    setOpen(!open)
  }

  const handlerSubmit = async (values) => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.dashboard
      .EmpresaSolicitudEmpresa({
        sNombreEmpresaReferida: values.nombreEmpresa,
        sNombreContactoEmpresa: values.nombreContactoEmpresa,
        sTelefonoContactoEmpresa: values.telefonoContactoEmpresa,
        sEmailContactoEmpresa: values.mailContactoEmpresa,
        sNombreSolicitante: values.tuNombre,
        sEmailSolicitante: values.tuCorreo,
      })
      .then(() => {
        handleSetTitle('La solicitud ha sido enviada.', 200)
        handleChangeBody(
          <Button
            variant="primary"
            onClick={() => {
              handleClose()
              handleToggleModal()
            }}
          >
            Continuar
          </Button>,
        )
        handleOpen()
      })
      .catch((error) => {
        handleSetTitle(
          '¡Ups! parece que algo salió mal 😕',
          error?.response?.status || 500,
        )
        handleChangeBody(
          <Text textAlign="center">Inténtalo nuevamente en unos minutos.</Text>,
        )
        handleOpen()
      })
      .finally(() => {
        handleCLoseLoading()
      })
  }

  return (
    <>
      <Button
        onClick={handleToggleModal}
        style={{
          margin: 0,
          paddingTop: 25,
          paddingBottom: 25,
          width: 'fit-content',
          boxShadow: '3px 4px 9px 0px #00000026',
        }}
      >
        <HStack>
          <UserIcon width="30" height="30" color="#ffffff" />
          <Text style={{ color: '#FFFFFF', textAlign: 'start' }} fontSize={14}>
            Entrega de
            <br />
            Referido Empresa
          </Text>
        </HStack>
      </Button>

      <Modal isOpen={open} onClose={handleToggleModal} isCentered>
        <ModalOverlay />
        <ModalContent backgroundColor="#f5f5f5" borderRadius={14}>
          <Formik
            initialValues={initialValue}
            onSubmit={handlerSubmit}
            validationSchema={validateSchema}
            validateOnBlur
            validateOnMount
          >
            {({
              values,
              handleBlur,
              handleChange,
              handleSubmit,
              errors,
              touched,
            }) => (
              <Form>
                <ModalBody p="20px 20px 20px 20px">
                  <VStack alignItems="flex-start" mb={10}>
                    <Image
                      width={91.23}
                      src={DashboardImage}
                      alt="Imagen referidos"
                    />
                    <Text variant="h5">Formulario Entrega de Referidos</Text>
                    <Text variant="body1">
                      Completa la información para poder gestionar al referido a
                      enviar.
                    </Text>
                  </VStack>
                  <VStack alignItems="flex-start" gap={3}>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Nombre empresa
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Nombre empresa"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="nombreEmpresa"
                        name="nombreEmpresa"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.nombreEmpresa}
                      />
                      {errors.nombreEmpresa && touched.nombreEmpresa ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.nombreEmpresa}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        Nombre contacto empresa
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="Nombre contacto empresa"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="nombreContactoEmpresa"
                        name="nombreContactoEmpresa"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.nombreContactoEmpresa}
                      />
                      {errors.nombreContactoEmpresa &&
                      touched.nombreContactoEmpresa ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.nombreContactoEmpresa}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        teléfono contacto empresa
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="+56"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="telefonoContactoEmpresa"
                        name="telefonoContactoEmpresa"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.telefonoContactoEmpresa}
                      />
                      {errors.telefonoContactoEmpresa &&
                      touched.telefonoContactoEmpresa ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.telefonoContactoEmpresa}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        mail contacto empresa
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="mail@correo.com"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="mailContactoEmpresa"
                        name="mailContactoEmpresa"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.mailContactoEmpresa}
                      />
                      {errors.mailContactoEmpresa &&
                      touched.mailContactoEmpresa ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.mailContactoEmpresa}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        tu nombre
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="tu nombre"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="tuNombre"
                        name="tuNombre"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tuNombre}
                      />
                      {errors.tuNombre && touched.tuNombre ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.tuNombre}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                    <Box w="100%">
                      <Text variant="overline" mb={2}>
                        tu correo
                      </Text>
                      <Input
                        w="100%"
                        backgroundColor="#fff"
                        placeholder="mail@correo.com"
                        style={{
                          border: '1px solid #E3E8EE',
                          boxShadow: '0px 1px 2px 0px #37415114',
                        }}
                        id="tuCorreo"
                        name="tuCorreo"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tuCorreo}
                      />
                      {errors.tuCorreo && touched.tuCorreo ? (
                        <Box>
                          <Text color={colors.log.error} variant="body3">
                            {errors.tuCorreo}
                          </Text>
                        </Box>
                      ) : null}
                    </Box>
                  </VStack>
                  <Button mt={7} borderRadius={5} onClick={handleSubmit}>
                    Enviar
                  </Button>
                </ModalBody>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  )
}
